class LoginController
{

    constructor ( authService, $state, $cookies, $q, GlobalRedirects, toaster )
    {
        'ngInject';

        // this.user = {
        //     email: 'superadmin@minto.com',
        //     password: 'super_admin'
        // };

        Object.assign( this, { authService, $state, $cookies, $q, GlobalRedirects, toaster } )
    }

    login ()
    {
        this.loginError = false;
        if ( this.loginForm.$valid )
        {
            this.authService.login( { userName: this.user.email, password: this.user.password } )
                .then( data =>
                {
                    if ( !data )
                    {
                        this.toaster.pop( 'error', "Authentication failed", 'Invalid Email or Password', 4000, 'trustedHtml' );
                        // this.$q.reject();
                        throw 'Invalid Email or Password';
                    }
                } )
                .then( data =>
                {
                    this.$state.go( this.GlobalRedirects.AFTER_LOGIN );
                } )
                .catch( error =>
                {
                    this.loginError = true;
                } );
        } else
        {
            switch ( true )
            {
                case !this.user: {
                    this.loginForm.$$controls[ 0 ].$untouched = false;
                    this.loginForm.$$controls[ 1 ].$untouched = false;
                    break;
                }
                case !this.user.email: {
                    this.loginForm.$$controls[ 0 ].$untouched = false;
                }
                case !this.user.password: {
                    this.loginForm.$$controls[ 1 ].$untouched = false;
                }
            }
        }
    }

}

export default LoginController;



// WEBPACK FOOTER //
// ./client/app/modules/auth/login/login.controller.js